<template>
        <ReactiveModal id="task-list-modal" class="modal_plan-task plan-task" title="Список проектных задач" v-on:close="$emit('close')">
            <template v-if="hideHeaderBtn" v-slot:left-actions>
                <div></div>
            </template>
            <template v-if="urlTasks.length">
                <div v-for="urlTask in urlTasks">
                    <div class="icon-text">
                        <Icon v-if="isAccessAllow" id="delete" color="purple" @click="confirmDelete(urlTask)"></Icon>
                        <a href @click.prevent="openTask(urlTask)">{{ urlTask.name }}</a>
                    </div>
                </div>
            </template>
            <p v-else>Пока нет проектных задач</p>
        </ReactiveModal>
</template>

<script>
import {mapState} from "vuex";
import {openPlanUrlTask, setPlanAction} from "@/vue/plan/store/planCRUD";

export default {
    name: "PlanUrlTaskListModal",
    props: ['hideHeaderBtn', 'isAccessAllow', 'urlId', 'service'],
    computed: {
        ...mapState({
            urlTasks: state => state.planUrl.urlTasks,
            runId: state => state.planCRUD.runId,
            resultId: state => state.planCRUD.resultId,
        }),
    },
    async created() {
      await this.init();
    },
    methods: {
        async init() {
            await this.$store.dispatch('fetchPlanUrlTaskList', {
                service: this.service,
                urlId: this.urlId,
                runId: this.runId
            });
        },
        openTask(urlTask) {
            openPlanUrlTask(this.resultId, urlTask.id, '', urlTask.runId, this.service, this.urlId);
            setPlanAction('view');
        },
        confirmDelete(urlTask) {
            this.$dialog.showConfirm({body: 'Действительно удалить?'}, () => this.deleteTask(urlTask));
        },
        deleteTask(urlTask) {
            this.$store.dispatch('deletePlanUrlTask', {task: urlTask, runId: urlTask.runId, service: this.service, urlId: this.urlId})
                .catch(e => {
                    if (400 === e.response.status || 400 === e.response.data?.status) {
                        if (e.response.data?.message) {
                            return this.$emit('requestError', e.response.data.message);
                        }
                    }

                    this.$emit('requestError', 'При удалении задачи произошла ошибка.');
                });
        }
    }
}
</script>
